import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Loading from "../../loadingPage/Loading";
import MultiFileInput from "../MultiFileInput";
import FileInputImg from "../FileInputImg";
import axios from "axios";
import { baseURL, CreateSI } from "../../../utils/EndPoint";
import { validateForm6Data } from "../../../utils/validation/formValidation";

const Form6 = () => {
  const [loader, setLoader] = useState(false);
  const [agreed, setAgreed] = useState(false);

  const kmaPaymentDetails = {
    NonKmaAmount: 9440,
    NonKmaWithGSTAmount: 9440,
    KMAAmount: 5900,
    KMAWithGSTAmount: 5900,
  };

  const initialData = {
    formName: "Sustainability Innovation Award",
    basicInformation: { 
      organizationName: "", 
      contactDetails: "",
      category: "", // New field added
      membershipId: "",
    },
    realImpact: { q1: "", q2: "", q3: "" },
    economicSustainability: { q4: "", q5: "", q6: "" },
    growthPotential: { q7: "", q8: "", q9: "" },
    circularity: { q10: "", q11: "", q12: "" },
    integrations: { q13: "", q14: "", q15: "" },
    attachments: { supportedDocuments: [] },
    paymentDetails: { 
        mode: "", 
        amountWithGst: kmaPaymentDetails.NonKmaWithGSTAmount, 
        isKmaMember: "false",
        receipt: null 
    },
  };

  const [formData, setFormData] = useState(initialData);
  const [formErrors, setFormErrors] = useState({});

  /* ================= HANDLERS ================= */
const sectionHandler = (section) => (e) => {
  const { name, value } = e.target;

  setFormData((prev) => ({
    ...prev,
    [section]: {
      ...prev[section],
      [name]: value,
    },
  }));

  // Clear error instantly if value is non-empty
  if (value.trim() !== "") {
    setFormErrors((prev) => ({ ...prev, [name]: "" }));
  }
};
  // const paymentChangeHandler = (e) => {
  //   const { name, value } = e.target;
  //   if (name === "isKmaMember") {
  //     const isKma = value === "true";
  //     setFormData((prev) => ({
  //       ...prev,
  //       paymentDetails: {
  //         ...prev.paymentDetails,
  //         isKmaMember: value,
  //         amountWithGst: isKma ? kmaPaymentDetails.KMAWithGSTAmount : kmaPaymentDetails.NonKmaWithGSTAmount,
  //       },
  //     }));
  //   } else {
  //     setFormData((prev) => ({
  //       ...prev,
  //       paymentDetails: { ...prev.paymentDetails, [name]: value },
  //     }));
  //   }
  // };

const inPutChangeHandler = (e) => {
  const { name, value } = e.target;

  setFormData((prev) => {
    let updated = { ...prev };

    if (name === "isKmaMember") {
      const isKma = value === "true";
      updated.paymentDetails = {
        ...updated.paymentDetails,
        isKmaMember: value,
        amountWithGst: isKma ? 5900 : 9440,
      };
    } else if (name === "mode" || name === "membershipId") {
      updated.paymentDetails = {
        ...updated.paymentDetails,
        [name]: value,
      };
    }

    return updated;
  });

  // Clear error instantly for this field
  if (value.trim() !== "") {
    setFormErrors((prev) => ({ ...prev, [name]: "" }));
  }
};


const submitHandler = async (e) => {
  e.preventDefault();

  const errors = validateForm6Data(formData);
  setFormErrors(errors);

if (Object.keys(errors).length > 0) {
  const firstErrorKey = Object.keys(errors)[0];
  const firstErrorMessage = errors[firstErrorKey];

  toast.error(firstErrorMessage);
  return;
}

try {
    setLoader(true);
    toast.dismiss(); // 1. Clears any lingering errors before the request starts

    const response = await axios.post(
      `${baseURL}${CreateSI}`,
      formData
    );

    // 2. Wrap success logic in a 200 check
if (response.status === 200 || response.status === 201) {
        toast.dismiss(); // 3. Instantly clear any toasts the moment upload succeeds

      if (response?.data?.redirectUrl) {
        toast.warning(
          "Please wait for the Payment Gateway. DO NOT CLOSE THE WINDOW."
        );
        window.location.href = response.data.redirectUrl;
        return;
      }

      toast.success("Application submitted successfully!");
      setFormData(initialData);
      setAgreed(false);
      window.scrollTo(0, 0);
    }

  } catch (error) {
    toast.error(
      error?.response?.data?.msg || "Something went wrong. Try again."
    );
  } finally {
    setLoader(false);
  }
};

  return (
    <>
      <h1 className="font-bold text-textColor text-2xl text-center mb-5 lg:mb-10">
        Sustainability Innovation Award
      </h1>

      <div className="flex items-start justify-center border rounded-xl shadow-xl w-full max-w-[1280px] mx-auto font-sans">
        <form onSubmit={submitHandler} className="w-full md:px-20 p-5 md:p-10">
          
          {/* 1. BASIC INFORMATION */}
          <div className="text-start w-full font-semibold mb-2">
            <h2 className="text-black text-lg font-bold">Basic Information</h2>
          </div>
          
          <div className="w-full md:mt-3 flex flex-col gap-4 py-1">
            <div className="w-full space-y-2">
              <label className="text-[#777777] text-[12px] md:text-[13px] font-medium">
                Full Legal Name of the Organization
              </label>
              <input
                type="text"
                name="organizationName"
                value={formData.basicInformation.organizationName}
                onChange={sectionHandler("basicInformation")}
                className="border border-[#771D32]/40 w-full p-2 md:p-3 text-gray-700 text-[10px] md:text-xs rounded outline-none"
              />
            </div>
            <div className="w-full space-y-2">
              <label className="text-[#777777] text-[12px] md:text-[13px] font-medium">
                Name, designation, and contact details of responsible person
              </label>
              <textarea
                name="contactDetails"
                value={formData.basicInformation.contactDetails}
                onChange={sectionHandler("basicInformation")}
                rows={3}
                className="border border-[#771D32]/40 w-full p-2 md:p-3 text-gray-700 text-[10px] md:text-xs rounded outline-none"
              />
            </div>

            {/* NEW CATEGORY FIELD */}
            <div className="w-full space-y-2">
              <label className="text-[#777777] text-[12px] md:text-[13px] font-medium">
                Choose a Category*
              </label>
              <select
                name="category"
                required
                value={formData.basicInformation.category}
                onChange={sectionHandler("basicInformation")}
                className="border border-[#771D32]/40 w-full p-2 md:p-3 text-gray-700 text-[10px] md:text-xs rounded outline-none font-medium"
              >
                <option value="">Select a Category</option>
                <option value="Product">Product</option>
                <option value="Service">Service</option>
              </select>
            </div>
          </div>

          {/* 2. QUESTIONNAIRES */}
          {[
            { title: "Real Impact (Environmental & Social Benefits)", key: "realImpact", 
              qs: [
                { l: "1. What specific environmental problem does your innovation solve?", n: "q1" },
                { l: "2. What positive social impacts has your innovation created?", n: "q2" },
                { l: "3. How do you measure and verify these benefits?", n: "q3" }
              ] 
            },
            { title: "Economic Sustainability", key: "economicSustainability", 
              qs: [
                { l: "4. Describe your revenue model.", n: "q4" },
                { l: "5. What is the cost compared to alternatives?", n: "q5" },
                { l: "6. What economic value does this create for Kerala?", n: "q6" }
              ] 
            },
            { title: "Growth Potential", key: "growthPotential", 
              qs: [
                { l: "7. Requirements to replicate in 10 other places?", n: "q7" },
                { l: "8. Dependency on specialized technology or materials?", n: "q8" },
                { l: "9. Plan for scaling up over 3-5 years?", n: "q9" }
              ] 
            },
            { title: "Circularity and Resource Efficiency", key: "circularity", 
              qs: [
                { l: "10. Describe main materials used (Virgin vs Recycled).", n: "q10" },
                { l: "11. End-of-life plan for the product?", n: "q11" },
                { l: "12. Quantifiable resource savings?", n: "q12" }
              ] 
            },
            { title: "Integrations Capability", key: "integrations", 
              qs: [
                { l: "13. Who else benefits beyond direct customers?", n: "q13" },
                { l: "14. Does it solve multiple problems simultaneously?", n: "q14" },
                { l: "15. Integration with existing systems in Kerala?", n: "q15" }
              ] 
            }
          ].map((sec) => (
            <div key={sec.key}>
              <div className="text-start w-full font-semibold my-5">
                <h2 className="text-black text-lg font-bold">{sec.title}</h2>
              </div>
              <div className="space-y-4">
                {sec.qs.map((q) => (
                  <div key={q.n} className="w-full space-y-2">
                    <label className="text-[#777777] text-[12px] md:text-[13px] font-medium">{q.l}</label>
<textarea
  name={q.n}
  value={formData[sec.key][q.n]}
  onChange={sectionHandler(sec.key)}
  rows={4}
  className={`border w-full p-2 md:p-3 text-gray-700 text-[10px] md:text-xs rounded outline-none ${
    formErrors[q.n] ? "border-red-500" : "border-[#771D32]/40"
  }`}
/>

{formErrors[q.n] && (
  <p className="text-red-500 text-sm mt-1">
    {formErrors[q.n]}
  </p>
)}
                  </div>
                ))}
              </div>
            </div>
          ))}
{/* 3. FINANCE SECTION */}
          <div className="text-start w-full font-semibold my-5 border-t pt-5">
            <h2 className="text-black text-lg font-bold">Financial and Payment Details</h2>
          </div>

          <div className="w-full flex flex-col md:flex-row gap-4 py-1">
            {/* Membership Selection */}
            <div className="w-full space-y-2">
              <label className="text-[#777777] text-[12px] md:text-[13px] font-medium">is KMA Member?*</label>
              <select 
                name="isKmaMember" 
                value={formData.paymentDetails.isKmaMember} 
                onChange={inPutChangeHandler} 
                className="border border-[#771D32]/40 w-full p-2 md:p-3 text-gray-700 text-[10px] md:text-xs rounded outline-none font-medium"
              >
                <option value="false">Non-KMA Member</option>
                <option value="true">KMA Member</option>
              </select>
            </div>

            {/* Membership ID - Appears only if KMA Member is selected */}
            <div className={`w-full space-y-2 ${formData.paymentDetails.isKmaMember === "true" ? "block" : "hidden"}`}>
              <label className="text-[#777777] text-[12px] md:text-[13px] font-medium">Membership Id*</label>
              <input 
                type="text" 
                name="membershipId"
                value={formData.paymentDetails.membershipId || ""}
                onChange={inPutChangeHandler}
                placeholder="Enter your ID"
                className="border border-[#771D32]/40 w-full p-2 md:p-3 text-gray-700 text-[10px] md:text-xs rounded outline-none" 
              />
            </div>

            {/* Price Display */}
            <div className="w-full space-y-2">
              <label className="text-[#777777] text-[12px] md:text-[13px] font-medium">Application Amount (with GST) :</label>
              <input 
                type="text" 
                readOnly 
                value={formData.paymentDetails.amountWithGst} 
                className="border border-[#771D32]/40 w-full p-2 md:p-3 text-gray-700 text-[10px] md:text-xs rounded bg-gray-50 outline-none" 
              />
            </div>
          </div>

          <div className="w-full flex flex-col md:flex-row gap-4 py-1 mt-2">
            <div className="w-full space-y-2">
              <label className="text-[#777777] text-[12px] md:text-[13px] font-medium">Payment Details :*</label>
<select
  name="mode"
  value={formData.paymentDetails.mode}
  onChange={inPutChangeHandler}
                className="border border-[#771D32]/40 w-full p-2 md:p-3 text-gray-700 text-[10px] md:text-xs rounded outline-none font-medium"
              >
                <option value="">Select Mode</option>
                <option value="Cheque">Cheque</option>
                <option value="DD">DD</option>
                <option value="Online">Online</option>
              </select>
            </div>
{/* Payment Receipt - Only for Cheque / DD */}
  {formData.paymentDetails.mode !== "Online" &&
   formData.paymentDetails.mode !== "" && (
<FileInputImg
  className="w-full space-y-2"
  label="Payment Receipt (png or jpg)"
  name="receipt"
  allowedFileTypes={["image/png", "image/jpeg", "image/jpg"]}
  setFile={(file) => {
    if (!file) return;

    // Directly set the server object into state
    setFormData((prev) => ({
      ...prev,
      paymentDetails: { ...prev.paymentDetails, receipt: file },
    }));

    // Instantly clear the validation error
    setFormErrors((prev) => ({ ...prev, receipt: "" }));
  }}
/>


  )}
  {formErrors.receipt && (
  <p className="text-red-500 text-sm mt-1">{formErrors.receipt}</p>
)}
          </div>

          {/* 4. SUPPORTED DOCUMENTS */}
          <div className="text-start w-full font-semibold my-5 border-t pt-5">
            <h2 className="text-black text-lg font-bold">Required Attachments</h2>
          </div>
<MultiFileInput
  name="supportedDocuments"
  label="Upload Supporting Documents (Multiple)"
  setFiles={(newFiles) => {
    setFormData((prev) => {
      const existing = Array.isArray(prev.attachments?.supportedDocuments)
        ? prev.attachments.supportedDocuments
        : [];
      const updated = [...existing, ...newFiles];

      // Clear error when at least one file added
      if (updated.length > 0) {
        setFormErrors((prevErr) => ({ ...prevErr, supportedDocuments: "" }));
      }

      return {
        ...prev,
        attachments: {
          ...prev.attachments,
          supportedDocuments: updated,
        },
      };
    });
  }}
/>

{formErrors.supportedDocuments && (
  <p className="text-red-500 text-sm mt-1">{formErrors.supportedDocuments}</p>
)}

{Array.isArray(formData?.attachments?.supportedDocuments) &&
  formData.attachments.supportedDocuments.length > 0 && (
    <div className="mt-4 space-y-2">
      {formData.attachments.supportedDocuments.map((file, index) => (
        <div key={index} className="flex justify-between bg-gray-100 p-2 rounded text-sm">
          <span className="truncate">{file.name}</span>
          <button
            type="button"
            onClick={() => {
              setFormData((prev) => {
                const updated = prev.attachments.supportedDocuments.filter((_, i) => i !== index);
                // Optional: re-show error if empty now
                if (updated.length === 0) {
                  setFormErrors((p) => ({ ...p, supportedDocuments: "At least one document required." }));
                }
                return {
                  ...prev,
                  attachments: { ...prev.attachments, supportedDocuments: updated },
                };
              });
            }}
            className="text-red-500 hover:underline"
          >
            Remove
          </button>
        </div>
      ))}
    </div>
  )}

          {/* SUBMIT AREA */}
          <div className="w-full flex flex-col md:flex-row gap-2 py-1 mt-8">
            <span className="text-xs md:text-sm">
              <input 
                type="checkbox" 
                checked={agreed} 
                onChange={(e) => setAgreed(e.target.checked)} 
                className="me-2"
              />
              I agree to abide by the rules of the KMA Awards 2026 and confirm all information is correct.
            </span>
          </div>

{/* Locked Submit Button Area */}
<div className="w-full flex justify-center mt-10">
  <button
type="submit"
disabled={!agreed}
    className="flex items-center justify-center border p-2 px-10 rounded bg-red-500 text-white font-medium"
  >
    {formData.paymentDetails.mode === "Online" ? "Pay Now & Submit" : "Submit"}
  </button>
</div>
        </form>
        {loader && <Loading />}
      </div>
    </>
  );
};

export default Form6;